// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* —— Patient — Add transaction drawer (Stitch) —— */
.patient-transaction-drawer.ant-drawer .ant-drawer-content-wrapper {
  width: 520px !important;
  max-width: calc(100vw - 24px);
}

.patient-transaction-drawer .ant-drawer-header {
  display: none;
}

.patient-transaction-drawer .ant-drawer-body {
  padding: 0 !important;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #ffffff;
}

.patient-transaction-drawer__shell {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.patient-transaction-drawer__header {
  flex-shrink: 0;
  padding: 16px 20px;
  border-bottom: 1px solid #E2E8F0;
  background: #ffffff;
}

.patient-transaction-drawer__title-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.patient-transaction-drawer__title-block {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}

.patient-transaction-drawer__title-copy {
  min-width: 0;
}

.patient-transaction-drawer__title-line {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.patient-transaction-drawer__title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
  color: #0F172A;
  line-height: 1.3;
}

.patient-transaction-drawer__badge {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 10px;
  border-radius: 9999px;
  background: #ECFDF5;
  color: #047857;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  white-space: nowrap;
}

.patient-transaction-drawer__subtitle {
  margin: 4px 0 0;
  font-size: 12px;
  line-height: 1.4;
  color: #64748B;
}

.patient-transaction-drawer__icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  background: #F1F5F9;
  color: #64748B;
  cursor: pointer;
  flex-shrink: 0;
}

.patient-transaction-drawer__icon-btn:hover {
  background: #E2E8F0;
  color: #0F172A;
}

[dir='rtl'] .patient-transaction-drawer__title-block > .patient-transaction-drawer__icon-btn svg {
  transform: scaleX(-1);
}

.patient-transaction-drawer__patient {
  margin: 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: #F8FAFC;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.patient-transaction-drawer__patient-main {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.patient-transaction-drawer__avatar {
  width: 32px;
  height: 32px;
  border-radius: 9999px;
  background: #E0F2FE;
  color: #0284C7;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.patient-transaction-drawer__patient-name {
  font-size: 13px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.patient-transaction-drawer__patient-meta {
  margin-top: 2px;
  font-size: 11px;
  color: #64748B;
  font-variant-numeric: tabular-nums;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.patient-transaction-drawer__patient-meta .is-balance {
  color: #059669;
  font-weight: 600;
}

.patient-transaction-drawer__patient-meta .is-due {
  color: #D97706;
  font-weight: 600;
}

.patient-transaction-drawer__account-chip {
  display: inline-flex;
  align-items: center;
  height: 22px;
  padding: 0 8px;
  border-radius: 9999px;
  background: #ECFDF5;
  color: #047857;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

.patient-transaction-drawer__body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #ffffff;
}

.patient-transaction-drawer__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.patient-transaction-drawer__label {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  color: #334155;
}

.patient-transaction-drawer__req {
  color: #F43F5E;
}

.patient-transaction-drawer__label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}

.patient-transaction-drawer__optional {
  font-size: 11px;
  font-weight: 500;
  color: #94A3B8;
}

.patient-transaction-drawer__amount-wrap {
  position: relative;
}

.patient-transaction-drawer__amount.ant-input-number {
  width: 100%;
}

.patient-transaction-drawer__amount .ant-input-number-input-wrap,
.patient-transaction-drawer__amount .ant-input-number-input {
  height: 36px !important;
}

.patient-transaction-drawer__amount.ant-input-number {
  border-radius: 8px !important;
  border-color: #E2E8F0 !important;
  box-shadow: none !important;
}

.patient-transaction-drawer__amount .ant-input-number-input {
  font-size: 13px !important;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  padding-inline-end: 48px !important;
}

.patient-transaction-drawer__currency {
  position: absolute;
  inset-inline-end: 12px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 12px;
  font-weight: 600;
  color: #64748B;
  pointer-events: none;
  font-variant-numeric: tabular-nums;
}

.patient-transaction-drawer__input-wrap {
  position: relative;
}

.patient-transaction-drawer__input--with-icon.ant-input {
  padding-inline-end: 36px !important;
}

.patient-transaction-drawer__input-icon {
  position: absolute;
  inset-inline-end: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #94A3B8;
  pointer-events: none;
}

.patient-transaction-drawer__amount.ant-input-number-focused {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;
}

.patient-transaction-drawer__amount .ant-input-number-handler-wrap {
  display: none;
}

.patient-transaction-drawer__select.ant-select {
  width: 100%;
}

.patient-transaction-drawer__select .ant-select-selector {
  height: 36px !important;
  border-radius: 8px !important;
  border-color: #E2E8F0 !important;
  box-shadow: none !important;
}

.patient-transaction-drawer__select .ant-select-selection-item,
.patient-transaction-drawer__select .ant-select-selection-placeholder {
  font-size: 12px !important;
  font-weight: 500;
  line-height: 34px !important;
}

.patient-transaction-drawer__select.ant-select-focused .ant-select-selector {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;
}

.patient-transaction-drawer__input.ant-input {
  height: 36px !important;
  border-radius: 8px !important;
  border-color: #E2E8F0 !important;
  font-size: 12px !important;
  font-variant-numeric: tabular-nums;
  box-shadow: none !important;
}

.patient-transaction-drawer__input.ant-input:focus {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;
}

.patient-transaction-drawer__textarea.ant-input {
  border-radius: 8px !important;
  border-color: #E2E8F0 !important;
  font-size: 12px !important;
  padding: 10px 12px !important;
  resize: none;
  box-shadow: none !important;
}

.patient-transaction-drawer__textarea.ant-input:focus {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;
}

.patient-transaction-drawer__footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 20px;
  border-top: 1px solid #E2E8F0;
  background: #ffffff;
}

.patient-transaction-drawer__ready {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  color: #64748B;
  font-variant-numeric: tabular-nums;
}

.patient-transaction-drawer__ready-dot {
  width: 8px;
  height: 8px;
  border-radius: 9999px;
  background: #10B981;
}

.patient-transaction-drawer__footer-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.patient-transaction-drawer__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}

.patient-transaction-drawer__btn--ghost {
  border: 1px solid #E2E8F0;
  background: #F8FAFC;
  color: #334155;
}

.patient-transaction-drawer__btn--ghost:hover {
  background: #F1F5F9;
  color: #0F172A;
}

.patient-transaction-drawer__btn--primary {
  border: 0;
  background: #0EA5E9;
  color: #ffffff;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.patient-transaction-drawer__btn--primary:hover:not(:disabled) {
  background: #0284C7;
}

.patient-transaction-drawer__btn--primary:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ShowPatient/components/drawers/AddTransactionDrawer.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;;EAEE,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,gCAAgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,0BAA0B;EAC1B,6BAA6B;EAC7B,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":["/* —— Patient — Add transaction drawer (Stitch) —— */\n.patient-transaction-drawer.ant-drawer .ant-drawer-content-wrapper {\n  width: 520px !important;\n  max-width: calc(100vw - 24px);\n}\n\n.patient-transaction-drawer .ant-drawer-header {\n  display: none;\n}\n\n.patient-transaction-drawer .ant-drawer-body {\n  padding: 0 !important;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.patient-transaction-drawer__shell {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.patient-transaction-drawer__header {\n  flex-shrink: 0;\n  padding: 16px 20px;\n  border-bottom: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.patient-transaction-drawer__title-row {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.patient-transaction-drawer__title-block {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  min-width: 0;\n}\n\n.patient-transaction-drawer__title-copy {\n  min-width: 0;\n}\n\n.patient-transaction-drawer__title-line {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.patient-transaction-drawer__title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.patient-transaction-drawer__badge {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 10px;\n  border-radius: 9999px;\n  background: #ECFDF5;\n  color: #047857;\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.patient-transaction-drawer__subtitle {\n  margin: 4px 0 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #64748B;\n}\n\n.patient-transaction-drawer__icon-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border: 0;\n  border-radius: 8px;\n  background: #F1F5F9;\n  color: #64748B;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.patient-transaction-drawer__icon-btn:hover {\n  background: #E2E8F0;\n  color: #0F172A;\n}\n\n[dir='rtl'] .patient-transaction-drawer__title-block > .patient-transaction-drawer__icon-btn svg {\n  transform: scaleX(-1);\n}\n\n.patient-transaction-drawer__patient {\n  margin: 0;\n  padding: 10px 12px;\n  border-radius: 8px;\n  background: #F8FAFC;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.patient-transaction-drawer__patient-main {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-width: 0;\n}\n\n.patient-transaction-drawer__avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 9999px;\n  background: #E0F2FE;\n  color: #0284C7;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.patient-transaction-drawer__patient-name {\n  font-size: 13px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.patient-transaction-drawer__patient-meta {\n  margin-top: 2px;\n  font-size: 11px;\n  color: #64748B;\n  font-variant-numeric: tabular-nums;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.patient-transaction-drawer__patient-meta .is-balance {\n  color: #059669;\n  font-weight: 600;\n}\n\n.patient-transaction-drawer__patient-meta .is-due {\n  color: #D97706;\n  font-weight: 600;\n}\n\n.patient-transaction-drawer__account-chip {\n  display: inline-flex;\n  align-items: center;\n  height: 22px;\n  padding: 0 8px;\n  border-radius: 9999px;\n  background: #ECFDF5;\n  color: #047857;\n  font-size: 11px;\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.patient-transaction-drawer__body {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  background: #ffffff;\n}\n\n.patient-transaction-drawer__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.patient-transaction-drawer__label {\n  margin: 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #334155;\n}\n\n.patient-transaction-drawer__req {\n  color: #F43F5E;\n}\n\n.patient-transaction-drawer__label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.patient-transaction-drawer__optional {\n  font-size: 11px;\n  font-weight: 500;\n  color: #94A3B8;\n}\n\n.patient-transaction-drawer__amount-wrap {\n  position: relative;\n}\n\n.patient-transaction-drawer__amount.ant-input-number {\n  width: 100%;\n}\n\n.patient-transaction-drawer__amount .ant-input-number-input-wrap,\n.patient-transaction-drawer__amount .ant-input-number-input {\n  height: 36px !important;\n}\n\n.patient-transaction-drawer__amount.ant-input-number {\n  border-radius: 8px !important;\n  border-color: #E2E8F0 !important;\n  box-shadow: none !important;\n}\n\n.patient-transaction-drawer__amount .ant-input-number-input {\n  font-size: 13px !important;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  padding-inline-end: 48px !important;\n}\n\n.patient-transaction-drawer__currency {\n  position: absolute;\n  inset-inline-end: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 12px;\n  font-weight: 600;\n  color: #64748B;\n  pointer-events: none;\n  font-variant-numeric: tabular-nums;\n}\n\n.patient-transaction-drawer__input-wrap {\n  position: relative;\n}\n\n.patient-transaction-drawer__input--with-icon.ant-input {\n  padding-inline-end: 36px !important;\n}\n\n.patient-transaction-drawer__input-icon {\n  position: absolute;\n  inset-inline-end: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #94A3B8;\n  pointer-events: none;\n}\n\n.patient-transaction-drawer__amount.ant-input-number-focused {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;\n}\n\n.patient-transaction-drawer__amount .ant-input-number-handler-wrap {\n  display: none;\n}\n\n.patient-transaction-drawer__select.ant-select {\n  width: 100%;\n}\n\n.patient-transaction-drawer__select .ant-select-selector {\n  height: 36px !important;\n  border-radius: 8px !important;\n  border-color: #E2E8F0 !important;\n  box-shadow: none !important;\n}\n\n.patient-transaction-drawer__select .ant-select-selection-item,\n.patient-transaction-drawer__select .ant-select-selection-placeholder {\n  font-size: 12px !important;\n  font-weight: 500;\n  line-height: 34px !important;\n}\n\n.patient-transaction-drawer__select.ant-select-focused .ant-select-selector {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;\n}\n\n.patient-transaction-drawer__input.ant-input {\n  height: 36px !important;\n  border-radius: 8px !important;\n  border-color: #E2E8F0 !important;\n  font-size: 12px !important;\n  font-variant-numeric: tabular-nums;\n  box-shadow: none !important;\n}\n\n.patient-transaction-drawer__input.ant-input:focus {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;\n}\n\n.patient-transaction-drawer__textarea.ant-input {\n  border-radius: 8px !important;\n  border-color: #E2E8F0 !important;\n  font-size: 12px !important;\n  padding: 10px 12px !important;\n  resize: none;\n  box-shadow: none !important;\n}\n\n.patient-transaction-drawer__textarea.ant-input:focus {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 2px rgba(14, 165, 233, 0.2) !important;\n}\n\n.patient-transaction-drawer__footer {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 20px;\n  border-top: 1px solid #E2E8F0;\n  background: #ffffff;\n}\n\n.patient-transaction-drawer__ready {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 11px;\n  color: #64748B;\n  font-variant-numeric: tabular-nums;\n}\n\n.patient-transaction-drawer__ready-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 9999px;\n  background: #10B981;\n}\n\n.patient-transaction-drawer__footer-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.patient-transaction-drawer__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 36px;\n  padding: 0 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, color 0.12s ease, border-color 0.12s ease;\n}\n\n.patient-transaction-drawer__btn--ghost {\n  border: 1px solid #E2E8F0;\n  background: #F8FAFC;\n  color: #334155;\n}\n\n.patient-transaction-drawer__btn--ghost:hover {\n  background: #F1F5F9;\n  color: #0F172A;\n}\n\n.patient-transaction-drawer__btn--primary {\n  border: 0;\n  background: #0EA5E9;\n  color: #ffffff;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.patient-transaction-drawer__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n}\n\n.patient-transaction-drawer__btn--primary:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
